import { Injectable } from '@angular/core';

import { TipoDeslocamento } from "./deslocamento-tipos.model";
import { apiName } from "./data.service";
import {RestService} from "../../core/services/rest.service";

@Injectable()
export class DeslocamentoTiposApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: TipoDeslocamento, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: TipoDeslocamento, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"nome"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamento-tipos/deslocamento-tipos-api.service.ts
 **/